class CodeParachuteHeader {
    constructor(header) {
        this.header = header
        this.init()
    }
    
    init() {
        const logo = this.header.querySelector('.custom-logo-link')
        const button = this.header.querySelector('.button')
        const menu = this.header.querySelector('.header-menu')

        if (menu) {
            const logoWidth = logo?.offsetWidth || 0;
            const buttonWidth = button?.offsetWidth || 0;
            const maxWidth = Math.max(logoWidth, buttonWidth);

            menu.style.paddingLeft = `${maxWidth}px`;
            menu.style.paddingRight = `${maxWidth}px`;
        }
    }
}

document.querySelectorAll('.codeparachute-header').forEach((header) => new CodeParachuteHeader(header))